/*
 * File: ui-pretty.ts
 * File Created: 2023-12-31 06:45:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:54:01
 * Modified By: Val Liu
 * -----
 */

import { DateHelper } from "../utilities";
import { NumberHelper } from "../utilities/number-helper";
import {
    BaseUITag,
    IUITagInput,
    IUITagResult,
    EUITagTarget,
    UITag,
    EUITagRuleType,
    EUITagRuleUnion,
} from "./core";

/// work for number / date.
type IUIPretty =
    | {
          /// for number
          decimal?: number;
      }
    | {
          /// for date
          date?: "full" | "long" | "medium" | "short" | undefined;
          time?: "full" | "long" | "medium" | "short" | undefined;
      };

// @uiPretty - apply pretty format to number and date.

@UITag.set()
export class uiPretty extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object, EUITagRuleType.Boolean];
    allowNullRule: boolean = true; /// default: true

    /// set prop value: number into pretty string
    parse(input: IUITagInput): IUITagResult | null {
        /// rule: true | false | IUIPretty
        const rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        const value = input.inputs?.props?.value;
        /// number pretty: readable format
        if (typeof value === "number") {
            let options: Intl.NumberFormatOptions = {};
            options.minimumFractionDigits = options.maximumFractionDigits = (
                rule as any
            ).decimal;
            return {
                props: { value: NumberHelper.toPrettyString(value, options) },
            };
        }

        /// date pretty
        if (value instanceof Date) {
            let options: Intl.DateTimeFormatOptions = {};
            options.dateStyle = (rule as any).date;
            options.timeStyle = (rule as any).time;
            return {
                props: {
                    is: "iv-cell-date",
                    data: options,
                },
            };
        }

        console.error(`<uiPretty> pretty format of type "${typeof value}" not defined.`);
        return null;
    }
}
